import { Feature, Geometry } from 'geojson';
import { useAppSelector } from '@customer/store/hooks';
import { FenceType, useGetSiteGeoJsonQuery } from '@customer/store/apis/geofencesApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { GeofenceProperties } from '@customer/store/apis/interactionsApi';
import { GeofenceTooltipContextProvider } from '../geofence-layer-group/GeofenceTooltipContextProvider';
import GeofenceLayerGroup from '../geofence-layer-group/GeofenceLayerGroup';
import GeofenceTooltipController from '../geofence-tooltip/GeofenceTooltipController';

const filterFns = {
  [FenceType.Standard]: (feature: Feature<Geometry, GeofenceProperties>) =>
    feature.properties.fenceType === FenceType.Standard,
  [FenceType.Intersection]: (feature: Feature<Geometry, GeofenceProperties>) =>
    feature.properties.fenceType === FenceType.Intersection,
  [FenceType.WetRoad]: (feature: Feature<Geometry, GeofenceProperties>) =>
    feature.properties.fenceType === FenceType.WetRoad,
};

const layers = [
  {
    key: 'geo-standard',
    layerNameTrans: 'GeofencesFenceType.Standard',
    filter: filterFns[FenceType.Standard],
  },
  {
    key: 'geo-intersections',
    layerNameTrans: 'GeofencesFenceType.Intersection',
    filter: filterFns[FenceType.Intersection],
  },
  {
    key: 'geo-wetroad',
    layerNameTrans: 'GeofencesFenceType.WetRoad',
    filter: filterFns[FenceType.WetRoad],
  },
];

interface AllGeofencesLayerProps {
  checked?: boolean;
}

export function AllGeofencesLayer({ checked = true }: AllGeofencesLayerProps) {
  const userData = useAppSelector(state => state.auth);

  // Cache this for a while as it doesn't change frequently and it's chunky
  const { data: geoJson } = useGetSiteGeoJsonQuery(userData.siteId ?? skipToken, {
    refetchOnMountOrArgChange: 1800,
  });

  if (geoJson === undefined) {
    return null;
  }

  return (
    <>
      {layers.map(({ key, layerNameTrans, filter }) => (
        <GeofenceTooltipContextProvider key={key}>
          <GeofenceLayerGroup
            key={key}
            layerNameTrans={layerNameTrans}
            checked={checked}
            geoJson={geoJson}
            filter={filter}
          >
            <GeofenceTooltipController />
          </GeofenceLayerGroup>
        </GeofenceTooltipContextProvider>
      ))}
    </>
  );
}

export default AllGeofencesLayer;
